import React, { useCallback } from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useBonusPayments, useCompanies, useUsers } from '../../../hooks';
import { SCREENS } from '../../../constants/permissions';
import AddIcon from '@mui/icons-material/Add';

// DB'den gelen ISO date string'i form input için Date objesine çevir.
// Pattern: ContractsPage'de aynı dönüştürme kullanılıyor (date input Date
// objesi bekliyor, string verince boş gözüküyordu).
const toFormDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

const buildFormFields = (fields, additionalData, isRootUser) => {
  const userList = additionalData?.users?.users || [];
  const companyList = additionalData?.companies?.companies || [];

  return fields
    .map((f) => {
      if (f.name === 'companyId') {
        return {
          ...f,
          options: companyList.map((c) => ({ value: c.id, label: c.name })),
          showIf: () => isRootUser,
        };
      }
      if (f.name === 'user_id') {
        return {
          ...f,
          options: userList.map((u) => ({
            value: u.id,
            // useUsers transformData first_name → firstName'e çeviriyor (camelCase).
            label: `${u.firstName || ''} ${u.lastName || ''}`.trim() || `Kullanıcı #${u.id}`,
          })),
        };
      }
      return f;
    })
    .filter((f) => (f.name === 'companyId' ? isRootUser : true));
};

const PrimTahsilatPage = () => {
  // Edit modal'a row verisini iletirken tarih string'ini Date'e çevir
  // ki form date input doğru initial value alsın.
  const transformEditData = useCallback((row) => ({
    ...row,
    tarih: toFormDate(row?.tarih),
  }), []);

  return (
    <DynamicCrudPage
      entityType="bonusPayments"
      screen={SCREENS.PRIM_MANAGEMENT}
      hook={useBonusPayments}
      additionalHooks={{ companies: useCompanies, users: useUsers }}
      addButtonTextKey="bonusPayments.actions.add"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="bonusPayments"
      customFormFields={buildFormFields}
      customTransformEditData={transformEditData}
    />
  );
};

export default PrimTahsilatPage;
